import React, { useEffect, useRef } from 'react';
import { scoringLines } from '../hooks/useTippspielBranding';

const ScoringInfo = ({ scoring, compact = false, open = false, onClose }) => {
  const panelRef = useRef(null);
  const lines = scoringLines(scoring);

  useEffect(() => {
    if (open && panelRef.current) {
      panelRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }, [open]);

  if (compact) {
    return (
      <p className="text-sm text-white/50 leading-relaxed -mt-2">
        Punkte werden automatisch nach Spielende vergeben.
        {' '}
        {lines.slice(0, 3).join(' · ')}
      </p>
    );
  }

  if (!open) return null;

  return (
    <div ref={panelRef} id="punkte-regeln" className="glass-card p-5 md:p-6">
      <div className="flex flex-wrap justify-between items-start gap-3 mb-1">
        <h3 className="panel-title border-0 pb-0 mb-0">Punktevergabe</h3>
        {onClose && (
          <button
            type="button"
            className="text-xs font-bold uppercase tracking-wide text-white/45 hover:text-white transition-colors"
            onClick={onClose}
          >
            Schließen ✕
          </button>
        )}
      </div>
      <p className="text-sm text-white/50 mb-4 mt-3">
        Du musst nichts manuell auslösen. Nach jedem Sync werden beendete Spiele automatisch
        ausgewertet. Admins können unter Admin → Punkte bei Bedarf neu berechnen.
      </p>
      <ul className="space-y-2">
        {lines.map((line) => (
          <li key={line} className="flex items-start gap-2 text-sm text-white/75">
            <span className="text-primary mt-0.5">▸</span>
            {line}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ScoringInfo;
